<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" v-for="(item, index) in itemsForTrenchEdit" :key="index"
			@click="onCMClickForTrenchSegmentEdit($event, item.id)">
			<v-list-item-title>
				{{ $t(item.title) }}
			</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script lang="ts">
import * as constant from "@/constant";
import { HorizontalAlignmentType } from "earthbrain-viewer";
import { useStore, mapActions } from "vuex";

export default {
	setup() {
		const store = useStore();
		return { store };
	},
	props: {
		pathId: String,
		segmentId: String,
		point: Array,
	},

	data: () => ({
		itemsForTrenchEdit: [
			{ id: 1, title: "ADD" },
			{ id: 2, title: "TangentAlignment" },
			{ id: 3, title: "SimpleCurveAlignment" },
			// { id: 4, title: "SpiralTransitionedAlignment" },
			{ id: 5, title: "Undo" },
			{ id: 6, title: "Redo" },
		],
	}),
	methods: {
		...mapActions("object", ["endEdit"]),

		onCMClickForTrenchSegmentEdit(e, id) {
			e.preventDefault();
			switch (id) {
				case 1:
					this.store.getters.viewer.addControlPointOnCenterLineOfTrench(
						this.pathId,
						this.point,
					);
					break;
				case 2:
					this.updateTrenchHorizontalAlignmentType(
						HorizontalAlignmentType.TANGENT,
					);
					break;
				case 3:
					this.updateTrenchHorizontalAlignmentType(
						HorizontalAlignmentType.SIMPLE_CIRCULAR,
					);
					break;
				case 4:
					this.updateTrenchHorizontalAlignmentType(
						HorizontalAlignmentType.SPIRAL_TRANSITIONED,
					);
					break;
				case 5:
					this.store.getters.viewer.undo();
					break;
				case 6:
					this.store.getters.viewer.redo();
					break;
			}
		},
		updateTrenchHorizontalAlignmentType(type) {
			this.store.getters.viewer.updateTrenchHorizontalAlignmentType(
				this.pathId,
				type,
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
	background-color: #0064ba !important;
}
</style>
